import store from "ui/redux/store"

store.subscribe(() => WDID = store.getState().wdid)

export var WDID = store.getState().wdid